<template>
  <transition name="fades">
    <div class="no-network" style="z-index: 10000" @mousewheel.prevent @scroll.stop.prevent>
      <div class="NoNetwork_box">
        <div class="NoNetwork_box_img img_reset">
          <img src="../../../assets/img/NoNetwork.png">
        </div>
        <div class="NoNetwork_box_title bold">你的网络异常，请检查后重试</div>
        <div class="NoNetwork_box_text">很抱歉！暂时无法使用，请稍后再试</div>
        <div class="NoNetwork_box_btn cursor" @click="btn">点击刷新</div>
      </div>
    </div>
  </transition>
</template>

<script type="text/javascript">

export default {
  name: 'NoNetwork',
  data () {
    return {
    }
  },
  methods: {
    btn () {
      location.reload()
    }
  }
}
</script>
<style lang="scss" scoped>
.no-network{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  .NoNetwork_box{
    background: #FFFFFF;
    border-radius: 16px;
    text-align: center;
    width: 400px;
    height: 400px;
    .NoNetwork_box_img{
      width: 186px;
      padding-top: 56px;
      margin: 0 auto;
      img{
        width: 100%;
      }
    }
    .NoNetwork_box_title{
      margin-top: 24px;
      font-size: 18px;
    }
    .NoNetwork_box_text{
      color: #999;
      margin-top: 8px;
      font-size: 14px;
    }
    .NoNetwork_box_btn{
      background: #2A6BFF;
      border-radius: 43px;
      width: 120px;
      line-height: 48px;
      color: #fff;
      margin: 24px auto 0;
    }
  }
}
body{
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/plugin/NoNetwork/src/main.vue